<form [formGroup]="form" novalidate>

  <mat-form-field class="form-field">
    <input
      class="form-field__text"
      matInput
      #input
      [placeholder]="placeholder"
      [matAutocomplete]="autocomplete"
      [formControlName]="controlName"
      (keyup)="setInputValue(input.value)"
      (blur)="setAutocompleteValue()"
      [required]="required"
      appFormControl
    >
  </mat-form-field>

  <mat-autocomplete
    #autocomplete="matAutocomplete"
    class="form-field"
    aria-required="true"
    [displayWith]="displayFn"
  >
    <mat-option
      *ngFor="let element of filteredArray | async"
      [value]="element[valueParameter] || element"
      (click)="emitElementClick(element)"
    >
      {{ element[displayParameter] || element }}
    </mat-option>
  </mat-autocomplete>
</form>
